var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1626 3.84467L2.89709 0.211348C2.59189 0.0587422 2.25274 -0.0133137 1.91186 0.00202334C1.57097 0.0173604 1.23966 0.119581 0.949396 0.298979C0.659129 0.478376 0.419538 0.728995 0.253375 1.02704C0.0872119 1.32508 -7.35885e-06 1.66064 4.6568e-10 2.00187V8.87038C-7.35885e-06 9.21161 0.0872119 9.54718 0.253375 9.84522C0.419538 10.1433 0.659129 10.3939 0.949396 10.5733C1.23966 10.7527 1.57097 10.8549 1.91186 10.8702C2.25274 10.8856 2.59189 10.8135 2.89709 10.6609L10.1626 7.02758C11.4749 6.37143 11.4749 4.50083 10.1626 3.84467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarline);
export default __webpack_public_path__ + "static/media/Starline.d29fa1353a60a918dd86b430ec76d56a.svg";
export { ForwardRef as ReactComponent };